import { useEffect } from 'react';

const EliminarMetodoPago = ({ show, onClose, metodo, onDelete }) => {
    useEffect(() => {
        if (!show) return;

        const prevOverflow = document.body.style.overflow;
        const prevPaddingRight = document.body.style.paddingRight;

        document.body.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = prevPaddingRight;

        return () => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = prevOverflow;
            document.body.style.paddingRight = prevPaddingRight;
        };
    }, [show]);

    if (!show) return null;

    return (
        <>
            <div
                className="modal fade show"
                role="dialog"
                aria-modal="true"
                tabIndex="-1"
                style={{ display: 'block', zIndex: 1055 }}
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Eliminar método de pago</h5>
                            <button type="button" className="btn-close" onClick={onClose} />
                        </div>

                        <div className="modal-body">
                            <div className="alert alert-warning m-0" role="alert">
                                ¿Seguro que deseas eliminar el método <strong>{metodo?.nombre || ''}</strong>?<br />
                                Esta acción no se puede deshacer.
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>
                                Cancelar
                            </button>
                            <button type="button" className="btn btn-danger" onClick={onDelete}>
                                Eliminar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={onClose}
            />
        </>
    );
};

export default EliminarMetodoPago;
